module.exports = __webpack_public_path__ + "img/img_35.0555eacd.png";